/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Block } from '~core/models/core.models';
import { SKIP_ERROR_INTERCEPTOR } from '~core/constants/global.constants';
import {
  BlockListParams,
  Pagination,
  BlockCreationParams
} from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class BlockService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  read(blockId: string): Observable<Block> {
    return this._httpClient.get<Block>(
      `${this._apiConstantsService.blockUrl}/${blockId}`
    );
  }

  list(params?: BlockListParams): Observable<Pagination<Block>> {
    return this._httpClient.get<Pagination<Block>>(
      this._apiConstantsService.blockUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  create(data: BlockCreationParams): Observable<Block> {
    return this._httpClient.post<Block>(
      this._apiConstantsService.blockUrl,
      data
    );
  }

  update(
    blockId: string,
    data: Partial<BlockCreationParams>
  ): Observable<Block> {
    return this._httpClient.patch<Block>(
      `${this._apiConstantsService.blockUrl}/${blockId}`,
      data
    );
  }

  delete(blockId: string, skipErrorInterceptor = false): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.blockUrl}/${blockId}`,
      {
        ...(skipErrorInterceptor && {
          context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
        })
      }
    );
  }
}
